// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"login_clearfix_dqtjC","form":"login_form_2sJPa"};